document.querySelectorAll('.preview-careers__header').forEach((item, i) => item.addEventListener('click', function () {
    document.querySelectorAll('.preview-careers').forEach((subitem, k) => {
        if (i !== k) {
            subitem.classList.remove('active');
            subitem.querySelector('.preview-careers__content').style.maxHeight = null;
        }
    })

    const parent_el = this.closest('.preview-careers');
    const panel_el = parent_el.querySelector('.preview-careers__content');

    parent_el.classList.toggle('active');

    if (panel_el.style.maxHeight) {
        panel_el.style.maxHeight = null;
    }
    else {
        panel_el.style.maxHeight = `${panel_el.scrollHeight}px`;
    }
}));